import chroma from 'chroma-js';

export class ColorUtils {
  static isColor(strColor: string) {
    const s = new Option().style;
    s.color = strColor;
    return s.color === strColor || /^#[0-9A-F]{3,8}$/i.test(strColor);
  }

  static generateColorRange(scales: string[], count: number) {
    return chroma.scale(scales).colors(count);
  }

  static random() {
    return chroma.random().hex();
  }

  static alpha(color: string | number | chroma.Color, value?: number) {
    return chroma(color).alpha(value ?? 1);
  }

  static rgbToHex(color: string, alpha?: number) {
    let cColor = chroma(color);

    if (typeof alpha === 'number') {
      cColor = cColor.alpha(alpha);
    }

    return cColor.hex();
  }
}
